import * as React from 'react'
import styled from 'styled-components'
import { theme } from 'utils/styledHelper'

import injectE2E from './injectE2E'

export type Weight = 100 | 200 | 300 | 400 | 500 | 600 | 700

export type PropsType = {
  capitalize?: boolean
  children?: React.ReactNode
  e2e?: string
  italic?: boolean
  opacity?: number
  size?: string
  uppercase?: boolean
  weight?: Weight
}

const getTextTransform = (props: PropsType) => {
  if (props.capitalize === true) {
    return 'capitalize'
  }

  if (props.uppercase === true) {
    return 'uppercase'
  }

  return 'none'
}

const Wrapper = styled.span.attrs(injectE2E)<PropsType>`
  font-family: ${theme('fontPrimary')};
  font-weight: ${(p) => p.weight};
  font-size: ${(p) => p.size};
  text-transform: ${getTextTransform};
  font-style: ${(props) => (props.italic === true ? 'italic' : 'normal')};
  color: ${theme('textColor')};
  opacity: ${(p) => p.opacity};
`

const Text = ({ children, ...rest }: PropsType) => <Wrapper {...rest}>{children}</Wrapper>

Text.defaultProps = {
  capitalize: false,
  italic: false,
  opacity: 1,
  size: '1rem',
  uppercase: false,
  weight: 400
}

export default Text
